import styled from '@emotion/styled';
import { KizenTypography } from 'app/typography';

import Icon, { IconSizing } from 'components/Kizen/Icon';

const DiscrepancyWarning = styled.div`
  position: absolute;
  left: 0;
  top: ${({ topOffset }) => (topOffset ? topOffset : 45)}px;

  & > i {
    float: left;
    color: var(--color-background-dark);

    &:hover {
      color: var(--color-background-dark);
    }
  }

  & > p {
    margin-left: 24px;
    font-style: italic;
    color: var(--color-font-placeholder);
  }
`;

export const TimezoneWarning = ({
  className = '',
  topOffset = 0,
  children,
}) => (
  <DiscrepancyWarning topOffset={topOffset} className={className}>
    <IconSizing size="15px">
      <Icon icon={['fal', 'globe']} />
    </IconSizing>
    <KizenTypography type="label-small">{children}</KizenTypography>
  </DiscrepancyWarning>
);
